/**
 * iOS Safari never fires `beforeinstallprompt`, so the regular InstallCard
 * can't appear there — those users need the manual "Share → Add to Home
 * Screen" path instead. Pure + injectable for tests.
 */
export function isIosSafari(
  ua: string = navigator.userAgent,
  standalone: boolean = matchStandalone(),
): boolean {
  const isIos = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && isTouchDevice());
  // Chrome/Firefox/Edge on iOS are Safari underneath but DO get their own
  // install flows via the share sheet too — the same hint applies, so we only
  // exclude the already-installed (standalone) case.
  return isIos && !standalone;
}

function matchStandalone(): boolean {
  try {
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      (navigator as { standalone?: boolean }).standalone === true
    );
  } catch {
    return false;
  }
}

function isTouchDevice(): boolean {
  try {
    return navigator.maxTouchPoints > 1; // iPadOS masquerades as Macintosh
  } catch {
    return false;
  }
}
